var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSafe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u642C\\u7816\\u83B7\\u5229\\u8BF4\\u660E",
    transform: "translate(-134.000000, -440.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(134.000000, 440.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#F2F6FE",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5B89\\u5168",
    transform: "translate(13.818182, 13.818182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u590D\\u5236-6",
    x: 0,
    y: 0,
    width: 36.3636364,
    height: 36.3636364
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3634596,5.84693142 C32.3627482,5.37665473 32.053262,4.96187212 31.6021948,4.8274057 C27.2537363,3.52258359 23.3719972,2.75776145 18.2017996,2.18788001 C18.1448826,2.18147687 18.0872541,2.18076541 18.0303371,2.18289978 C15.4093095,2.31807767 12.9597442,2.64392746 10.7492304,3.15120019 C8.52519876,3.66203022 6.4043292,4.22693142 4.44780744,4.8295401 C4.00100903,4.96685236 3.69508017,5.3809235 3.69508017,5.84906579 C3.69508017,7.5444808 3.67729363,9.10542942 3.6623529,10.5518326 C3.52717504,22.8572872 3.4766612,27.4618722 15.5373727,34.1254295 C16.5319972,34.6746785 17.2953964,34.9087496 18.0893885,34.9087496 C18.8691513,34.9087496 19.6517601,34.6732556 20.6257521,34.1460619 C32.6402186,27.6390263 32.5875703,23.7857457 32.4118391,11.018552 C32.3904952,9.44621999 32.367017,7.73088397 32.3634596,5.84693142 Z",
    id: "\\u8DEF\\u5F84",
    stroke: "#3E7DFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-3",
    stroke: "#3E7DFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero",
    points: "11.6363636 17.9547148 16.3451367 21.8181818 24.7272727 14.5454545"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSafe);
export default __webpack_public_path__ + "static/media/icon_safe.e03bcce8ea54cc248b991b59f15bdd7f.svg";
export { ForwardRef as ReactComponent };